import React from 'react'
import { observer } from 'mobx-react-lite'
import CopyToClipboard from '../copyToClipboard/copyToClipboard'

export const PositionRowCell = observer((
  {
    children,
    textContent,
    copy = true
  }
) => {

  return (
    <div className={`text-Regular(16_18) p-[1.2rem]`}>
      {children || <div className={`flex items-center`}>
          {textContent}
        {copy && <CopyToClipboard string={textContent}></CopyToClipboard>}
        </div>
      }
    </div>
  )
})